import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthMiddleware, GuestMiddleware } from './middleware';
import { lazy, Suspense } from 'react';
import { AssessmentProvider } from '@/contexts/AssessmentProvider';
import { PageLoader } from '@/components/PageLoader';
import { ChunkErrorBoundary } from '@/components/ChunkErrorBoundary';

const AuthLayout = lazy(() => import('@/layout/AuthLayout'));
const AppLayout = lazy(() => import('@/layout/AppLayout'));
const LoginPage = lazy(() => import('@/pages/auth/Login'));
const RegisterPage = lazy(() => import('@/pages/auth/Register'));
const ForgetPasswordPage = lazy(() => import('@/pages/auth/ForgetPassword'));
const ResetPasswordPage = lazy(() => import('@/pages/auth/ResetPassword'));
const AssessmentsPage = lazy(() => import('@/pages/app/Assessments'));
const PatientsPage = lazy(() => import('@/pages/app/Patients'));
const PatientDetailPage = lazy(() => import('@/pages/app/Patients/PatientDetail'));
const Profile = lazy(() => import('@/pages/app/Profile'));
const Logout = lazy(() => import('@/pages/app/Logout'));
const LinkedUsers = lazy(() => import('@/pages/app/Profile/organization/LinkedUsers'));
const NewAssessmentPage = lazy(() => import('@/pages/app/NewAssessment'));
const AssessmentReportPage = lazy(() => import('@/pages/app/AssessmentReport'));
const BeforeAfterReportPage = lazy(() => import('@/pages/app/BeforeAfterReport'));
const PresentationPage = lazy(() => import('@/pages/app/Presentation'));
const PdfRenderPage = lazy(() => import('@/pages/app/PdfRender'));

export default function AppRoutes() {
  return (
    <ChunkErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <Routes>
      <Route path="/" element={<Navigate to="/auth" />} />
      <Route element={<GuestMiddleware />}>
        <Route path="/auth" element={<AuthLayout />}>
          <Route path="" element={<LoginPage />} />
          <Route path="cadastrar" element={<RegisterPage />} />
          <Route path="recuperar-senha" element={<ForgetPasswordPage />} />
          <Route path="redefinir-senha" element={<ResetPasswordPage />} />
        </Route>
      </Route>
      {/* Rota pública de apresentação */}
      <Route path="/apresentacao/:id" element={<PresentationPage />} />
      {/* Só para Puppeteer (API) gerar PDF — JWT curto na query */}
      <Route path="/pdf-render/:id" element={<PdfRenderPage />} />
      
      <Route element={<AuthMiddleware />}>
        <Route path="/app" element={<AppLayout />}>

          {/* Rota principal agora é pacientes */}
          <Route path="" element={<PatientsPage />} />

          <Route element={<AssessmentProvider />}>
            <Route path="atendimentos" element={<AssessmentsPage />} />
            <Route path="atendimentos/novo" element={<NewAssessmentPage />} />
            <Route path="atendimentos/:id" element={<NewAssessmentPage />} />
          </Route>

          <Route path="pacientes" element={<PatientsPage />} />
          <Route path="pacientes/:id" element={<PatientDetailPage />} />
          
          <Route path="perfil/index" element={<Profile />} />
          <Route path="perfil/organizacoes" element={<Profile />} />
          <Route path="perfil/senha" element={<Profile />} />
          <Route
            path="perfil/organizacoes/:orgId/usuarios"
            element={<LinkedUsers />}
          />
          <Route path="logout" element={<Logout />} />
        </Route>
        
        {/* Rota do relatório sem layout padrão */}
        <Route path="/app/atendimentos/:id/relatorio" element={<AssessmentReportPage />} />
        <Route path="/app/pacientes/:id/antes-depois" element={<BeforeAfterReportPage />} />
      </Route>
        </Routes>
      </Suspense>
    </ChunkErrorBoundary>
  );
}
